/* eslint-disable */
import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
// import login from '../components/Login.vue'
const login = () =>
  import(/* webpackChunkName: "login-home-welcome" */ "../views/Login.vue");
// import home from '../components/Home.vue'
const home = () =>
  import(
    /* webpackChunkName: "login-home-welcome" */ "../views/travelHome.vue"
  );
// import welcome from '../components/Welcome.vue'
const welcome = () =>
  import(/* webpackChunkName: "login-home-welcome" */ "../views/Welcome.vue");

// import user from '../components/user/Users.vue'
const user = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/user/orgnize.vue"
  );
const user2 = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/user/Users2.vue"
  );

// ======================================
const travelMonitor = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/travelMonitor.vue"
  );
// import rights from '../components/power/Rights.vue'

const travelmobile = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/travelmobile.vue"
  );
// import rights from '../components/power/Rights.vue'

const WeChatChat = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/components/WeChatChat.vue"
  );
// import rights from '../components/power/Rights.vue'

// ======================================

const travelListenMain = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/travelListenMain.vue"
  );
// import rights from '../components/power/Rights.vue'

const mornitorPC = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/mornitorPC.vue"
  );
// import rights from '../components/power/Rights.vue'

const customers = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/customers.vue"
  );
// import rights from '../components/power/Rights.vue'

const messageList = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/messageList.vue"
  );
// import rights from '../components/power/Rights.vue'
// =======================

const charts = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/charts.vue"
  );
// import rights from '../components/power/Rights.vue'
// =======================

const creator = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/mornitorCenter.vue"
  );
// import rights from '../components/power/Rights.vue'
// =======================

const videourl = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/videourl.vue"
  );
// import rights from '../components/power/Rights.vue'
// =======================

const annlysisData = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/annlysisData.vue"
  );
// import rights from '../components/power/Rights.vue'
const dylogin = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/dylogin.vue"
  );
// import rights from '../components/power/Rights.vue'
// =======================

const dyVideoHost = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/dyVideoHost.vue"
  );
// import rights from '../components/power/Rights.vue'

const dyaccountList = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/dyaccountList.vue"
  );

const leadImg = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/leadImg.vue"
  );

const pinlun = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/pinlun.vue"
  );

// =======================
const wxlist = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/wxlist.vue"
  );
const wxuserset = () =>
  import(
    /* webpackChunkName: "user-rights-roles" */ "../views/travel/wxuserset.vue"
  );
// import rights from '../components/power/Rights.vue'
// =======================

// =======================

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", component: login },

  { path: "/travelMonitor", component: travelMonitor },

  //

  { path: "/travelmobile", component: travelmobile },

  { path: "/WeChatChat", component: WeChatChat },

  { path: "/travelListenMain", component: travelListenMain },

  { path: "/mornitorPC", component: mornitorPC },
  { path: "/customers", component: customers },
  { path: "/messageList", component: messageList },
  { path: "/wxlist", component: wxlist },
  { path: "/wxuserset", component: wxuserset },
  { path: "/charts", component: charts },
  { path: "/creator", component: creator },
  { path: "/pinlun", component: pinlun },
  { path: "/videourl", component: videourl },
  { path: "/dyaccountList", component: dyaccountList },
  { path: "/leadinfo", component: leadImg },

  { path: "/dyVideoHost", component: dyVideoHost },
  { path: "/dylogin", component: dylogin },
  { path: "/annlysisData", component: annlysisData },
  { path: "/users", component: user },
  { path: "/users2", component: user2 },

  {
    path: "/home",
    component: home,
    redirect: "/welcome",
    children: [{ path: "/welcome", component: welcome }],
  },
];

const router = new VueRouter({
  routes,
});

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个页面跳转而来
  // next 是一个函数， 表示方形
  //      next() 放行 next('/') 强制跳转
  // 首页直接放行
  if (to.path === "/login" || to.path === "/leadinfo") return next();
  // 获取token
  // const tokenStr = window.sessionStorage.getItem("token");
  const tokenStr = store.getters.getUserToken;
  // token不为空，放行
  if (!tokenStr) return next("/login");
  next();
});

export default router;
